import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Button,
  Media,
  Label
} from 'reactstrap';
import Fade from 'react-reveal/Fade';
import AvantagesSvg from './img/Avantages.svg';
import StructurePng from './img/Architecture1.png';

const Plugins = ({
	link
}) => {
	return(
		<div className="section"> 
			<Container>
				<Row>
					<Col lg={6}>
							<Fade left>
								<div className="imgContainer">
									<img className="imgContent" src={StructurePng} alt="Sections" /> 
								</div>
							</Fade>
					</Col>
					<Col lg={6}>
						<Row>
						<Fade right cascade>
								<Media className="app">
									<Media left href="#">
										<FormattedMessage id="section_alt">
											{
												alt =>  (
													<img
														className="icon" 
														src={AvantagesSvg}
														alt={alt} 
													/>
												)
											}
										</FormattedMessage>
									</Media>
									<Media body>
										<Media heading>
											<h2 className="label">
												Les Avantages        
											</h2>
										</Media>
										<Label className="subTitle">
											Architecture
										</Label>
									</Media>
								</Media>
							</Fade>
						</Row>
						<Row>
							<Fade right>
								<p className="lead">
									Pour les Architectes, le plugin TriDyme permet :
								</p>
							</Fade>
							<Fade right cascade>
								<ul className="lead">
									<li>
										Une vérification et une optimisation structurelle simplifiée <strong>dès la phase amont d'un Projet</strong>
									</li>
									<li>
										Une <strong>minimisation des risques des modifications</strong> importantes au moment du contrôle par un bureau d'étude structure
									</li>
									<li>
										Calcul et stockage des <strong>résultats dans le Cloud</strong> : donc possibilité de retrouver des résultats partout et de les partager
									</li>
									<li>
									<strong>Intégration dans un processus BIM</strong>
									</li>
								</ul>
							</Fade>
						</Row>
						<Row>
							<Col lg={12}>
								<Fade right>
									<Button
										href={link}
										className="negativeButton"
									>
										Essayez
									</Button>
								</Fade>
							</Col>
						</Row>
					</Col>
				</Row>
			</Container>    
		</div>       
	);
};

export default Plugins;

